import { useCallback, useEffect, useMemo, useState } from "react";
import { useTheme as useSCTheme } from "styled-components";
import defer from "lodash/defer";
import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "theme/constants";
const useThemeMode = () => {
  const theme = useSCTheme();
  const currentMode = theme.mode;
  const [loadingTheme, setLoadingTheme] = useState(false);
  useEffect(() => {
    if (loadingTheme) {
      setLoadingTheme(false);
    }
  }, [loadingTheme, theme]);
  const toggleThemeMode = useCallback(() => {
    setLoadingTheme(true);
    const newMode = currentMode === COLOR_SCHEME_LIGHT ? COLOR_SCHEME_DARK : COLOR_SCHEME_LIGHT;
    defer(() => theme.changeMode(newMode));
  }, [currentMode, theme]);
  return useMemo(
    () => ({
      currentMode,
      toggleThemeMode,
      loadingTheme
    }),
    [currentMode, loadingTheme, toggleThemeMode]
  );
};
export default useThemeMode;
